/**
 * Composable for arrow key navigation within a list of focusable elements.
 * Supports wrapping navigation (first <-> last).
 *
 * @param {Object} options
 * @param {Ref<HTMLElement>} options.containerRef - Vue ref to the container element
 * @param {string} options.selector - CSS selector for focusable elements
 * @returns {{ handleArrowKeyNavigation: Function }}
 */
export function useArrowKeyNavigation ({ containerRef, selector }) {
    function handleArrowKeyNavigation (event, currentIndex) {
        const { key } = event;
        const focusableElements = containerRef.value.querySelectorAll(selector);
        const totalFocusableElements = focusableElements.length;

        let nextIndex;
        if (key === 'ArrowUp' || key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + totalFocusableElements) % totalFocusableElements;
        } else if (key === 'ArrowDown' || key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % totalFocusableElements;
        }

        if (nextIndex !== undefined) {
            focusableElements[nextIndex]?.focus();
        }

        return nextIndex;
    }

    return { handleArrowKeyNavigation };
}
